import { ISiteInfo } from "../../interfaces/ISiteInfo";

const forwardSlashCharCode = 47;

const normalizeSiteIdentity = (value?: string): string | undefined => {
  const normalizedValue = value?.trim();
  return normalizedValue ? normalizedValue.toLowerCase() : undefined;
}

const normalizeSiteUrl = (webUrl?: string): string | undefined => {
  const trimmedWebUrl = webUrl?.trim();
  if (!trimmedWebUrl) return undefined;

  let endIndex = trimmedWebUrl.length;
  while (endIndex > 0 && trimmedWebUrl.charCodeAt(endIndex - 1) === forwardSlashCharCode) {
    endIndex--;
  }

  const normalizedWebUrl = endIndex === trimmedWebUrl.length
    ? trimmedWebUrl
    : trimmedWebUrl.substring(0, endIndex);

  return normalizedWebUrl ? normalizedWebUrl.toLowerCase() : undefined;
}

export const dedupeSitesByIdentity = (sites?: ISiteInfo[]): ISiteInfo[] => {
  if (!Array.isArray(sites) || sites.length === 0) return [];

  const seenSiteIds: Set<string> = new Set<string>();
  const seenSiteUrls: Set<string> = new Set<string>();
  const dedupedSites: ISiteInfo[] = [];

  for (const site of sites) {
    if (!site) continue;

    const siteId = normalizeSiteIdentity(site.id);
    const siteUrl = normalizeSiteUrl(site.webUrl);

    if ((siteId && seenSiteIds.has(siteId)) || (siteUrl && seenSiteUrls.has(siteUrl))) {
      continue;
    }

    if (siteId) seenSiteIds.add(siteId);
    if (siteUrl) seenSiteUrls.add(siteUrl);
    dedupedSites.push(site);
  }

  return dedupedSites;
}
